import { ReactNode } from 'react';

export type ViewerMessage = {
    text: ReactNode;
    timeout?: number;
    variant?: ViewerMessageValue;
    top?: number;
    action?: { label: string; actionClick: () => void };
};

export const VIEWER_MESSAGE = {
    GUIDANCE: 'Guidance',
    INFORMATION: 'Information',
    OUTCOME: 'Outcome',
    WARNING: 'Warning',
    ERROR: 'Error'
} as const;

// Type representing the keys of VIEWER_MESSAGE
export type ViewerMessageKey = keyof typeof VIEWER_MESSAGE;

// Type representing the values of VIEWER_MESSAGE
export type ViewerMessageValue = (typeof VIEWER_MESSAGE)[ViewerMessageKey];

